export enum Global {
    ERROR_404 = 404,
    DROPDOWN_TYPE = 'DROPDOWN',
    CARD_TYPE = 'CARD',
    LIMIT_RESULT_DESCRIPTION = 250,
    AUTOMATIC_CHOICE = 1,
}

export enum Brand {
    VW = 'VW',
    VIC = 'VI',
}

const VW_PURCHASE_URL = 'https://manutenzione-volkswagen.vwfs.it/form'
const VIC_PURCHASE_URL =
    'https://www.vwfs.it/servizi-manutenzione/VeicolicommercialiVW.html'
export const RESULTS_KEY = 'results'
export const RESULT_KEY = 'result'

export const getExternalPurchaseUrl = (brand?: string): string => {
    if (brand?.trim().toUpperCase() === Brand.VIC) {
        return VIC_PURCHASE_URL
    }

    return VW_PURCHASE_URL
}

export const URL_PARAMS: URLSearchParams = new URLSearchParams(
    window.location.search
)
